import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Header: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path: string) => location.pathname === path;

  return (
    <header className="header">
      <div className="container">
        <Link to="/" className="logo">
          HK<span>Design</span>
        </Link>

        <button
          className="mobile-menu-btn"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? "✕" : "☰"}
        </button>

        <nav className={`nav-links ${isMenuOpen ? "active" : ""}`}>
          <Link
            to="/"
            className={isActive("/") ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            Ana Sayfa
          </Link>
          <Link
            to="/hizmetler"
            className={isActive("/hizmetler") ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            Hizmetlerim
          </Link>
          <Link
            to="/portfoy"
            className={isActive("/portfoy") ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            Portföy
          </Link>
          <Link
            to="/hakkimda"
            className={isActive("/hakkimda") ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            Hakkımda
          </Link>
          <Link
            to="/iletisim"
            className={isActive("/iletisim") ? "active" : ""}
            onClick={() => setIsMenuOpen(false)}
          >
            İletişim
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;
